import createVueComponent from '../createVueComponent';

const ArrowRightToLine = createVueComponent('ArrowRightToLineIcon', [
  ['path', { d: 'M17 12H3', key: '8awo09' }],
  ['path', { d: 'm11 18 6-6-6-6', key: '8c2y43' }],
  ['path', { d: 'M21 5v14', key: 'nzette' }],
]);

export default ArrowRightToLine;
